import { LitElement, html, css } from "lit";
import { customElement, property, query, state } from "lit/decorators.js";
import { Routing } from "../mixins/routing";
import { app } from "../init";
import { featurebaseAuthenticate } from "../lib/featurebase";
import { enabledFeatures, EnabledFeatures } from "../contexts/features-context";
import { consume } from "@lit/context";

@customElement("ptc-feedback")
export class Feedback extends Routing(LitElement) {
    routePattern = /^feedback(?:\/(?<page>[^/]+))?/;

    @consume({ context: enabledFeatures, subscribe: true })
    features: EnabledFeatures;

    @state()
    private _loading = true;

    @query("iframe")
    private _iframe: HTMLIFrameElement;

    get routeTitle() {
        return "Feedback";
    }

    get helpPage() {
        return "feedback";
    }

    async updated() {
        this._iframe?.addEventListener(
            "load",
            () => {
                this._loading = false;
            },
            { once: true }
        );
        if (this.features.featureVoting && app.state.account && app.state.account.featurebaseUserHash) {
            featurebaseAuthenticate({
                accountId: app.state.account.id,
                firstName: app.state.account.firstName,
                lastName: app.state.account.lastName,
                email: app.state.account.email,
                id: app.state.account.id,
                featurebaseUserHash: app.state.account.featurebaseUserHash,
                companyId: app.state.company?.id,
                companyName: app.state.company?.name,
            });
        }
    }

    @property() content = `
    <!DOCTYPE html>
    <html>
    <head>
    <style>
          html,
            body {
                width: 100%;
                height: 100%;
                margin: 0;
                overscroll-behavior: none;
                position: fixed;
            }
    </style>
        <script>
            !(function (e, t) {
                const a = "featurebase-sdk";
                function n() {
                    if (!t.getElementById(a)) {
                        var e = t.createElement("script");
                        (e.id = a),
                            (e.src = "https://do.featurebase.app/js/sdk.js"),
                            t
                                .getElementsByTagName("script")[0]
                                .parentNode.insertBefore(e, t.getElementsByTagName("script")[0]);
                    }
                }
                "function" != typeof e.Featurebase &&
                    (e.Featurebase = function () {
                        (e.Featurebase.q = e.Featurebase.q || []).push(arguments);
                    }),
                    "complete" === t.readyState || "interactive" === t.readyState
                        ? n()
                        : t.addEventListener("DOMContentLoaded", n);
            })(window, document);
        </script>
        </head>
      <body>
        <div data-featurebase-embed></div>
        <script>
  Featurebase('init_embed_widget', {
   
    organization: 'pentacode', // Replace with your organization name (subdomain from your Featurebase workspace URL)
    
    embedOptions: {
      path: '/', // Initial page to load: '/' for feedback board, '/roadmap' for roadmap, '/changelog' for changelog, etc.
      filters: '', // Query params that can be used for default filters (e.g. 'b=63f827df2d62cb301468aac4&sortBy=upvotes:desc')
      // routeSyncingBasePath: '' // ADVANCED - Sync URLs between your website & the embed, read the documentation below for usage
    },
    
    /* Optional - Styling configuration */
    stylingOptions: {
      theme: 'light', // Theme options: 'light', 'dark', or '' for auto-detection
      hideMenu: true, // Toggle visibility of the top navigation bar
      hideLogo: true, // Toggle visibility of the logo in the navigation bar
    },
    
    locale: 'de'
  })
</script>
      </body>
    </html>
  `;

    createRenderRoot() {
        return this;
    }

    static styles = [
        css`
            iframe {
                width: 100%;
                height: 100%;
                border: none;
            }
        `,
    ];

    render() {
        return html` <iframe class="stretch" .srcdoc=${this.content}></iframe>

            <div class="fullbleed centering layout scrim" ?hidden=${!this._loading}>
                <ptc-spinner .active=${this._loading}></ptc-spinner>
            </div>`;
    }
}
